import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../hooks/useFetch';
import { AdhesionAdherentParticulierResponse, RaisonResiliation } from '../../../services/Api/swagger';

export interface ResiliationFormData {
  numeroAdhesion: string;
  raisonResiliation: string;
}

export const useResiliationForm = (selectedAdhesion?: AdhesionAdherentParticulierResponse) => {
  const methods = useForm<ResiliationFormData>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    criteriaMode: 'all',
    defaultValues: {
      numeroAdhesion: selectedAdhesion?.numeroAdhesion,
    },
  });

  const {
    watch,
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    clearErrors,
    reset,
  } = methods;

  const [paramsResiliationForm, setParamsResiliationForm] = useState<ResiliationFormData | undefined>();
  const [resiliationEnvoyee, setResiliationEnvoyee] = useState<boolean>(false);
  const { response, fetching, error: errorApi } = useFetch<RaisonResiliation>(
    paramsResiliationForm,
    'postDemanderResiliationAdhesion',
    paramsResiliationForm !== undefined,
  );

  useEffect(() => {
    if (response) {
      reset();
      setResiliationEnvoyee(true);
    }
  }, [response]);
  return {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    setValue,
    clearErrors,
    setParamsResiliationForm,
    response,
    fetching,
    errorApi,
    setResiliationEnvoyee,
    resiliationEnvoyee,
  };
};
